import { $api } from '@service/RequestService';
import { timeStampToDate } from '@utils/index';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';
import { NumberParam, StringParam, useQueryParams } from 'use-query-params';

import { sectionSettingsConstants, sectionSettingsModels } from '..';

type Props = {
  size?: number;
  search?: string;
  isPropsSearch?: boolean;
};

export function useDepartments(props?: Props) {
  const [{ page = 1, search }] = useQueryParams({
    page: NumberParam,
    search: StringParam
  });

  const initial: Pagination<sectionSettingsModels.DepartmentType> = {
    data: [],
    totalPages: 1,
    currentPage: 1,
    totalElements: 0
  };

  const searchValue = props?.isPropsSearch ? props?.search : search;

  const { data = initial, ...arg } = useQuery<Pagination<sectionSettingsModels.DepartmentType>>(
    [sectionSettingsConstants.queryKeys.DEPARTMENTS, page, searchValue],
    async () => {
      const { data } = await $api.get(
        `/v1/department?page=${page}&size=${props?.size || 12}${searchValue ? `&search=${encodeURI(searchValue)}` : ''}`
      );

      const finalData: Pagination<sectionSettingsModels.DepartmentType> = data?.data

      return {
        ...finalData,
        data: finalData?.data?.map(item => ({
          ...item,
          createdDate: timeStampToDate({
            date: item?.createdDate,
            timeStamp: item?.createdTimestamp
          })
        }))
      };
    }
  );

  return { ...data, ...arg };
}
